module.exports = __webpack_public_path__ + "media/images/talent/button-arrow-2459b407824fd9ead6d03b1d0e210eab.png";